<template>
    <div>
        <div v-if="loading" class="is-clearfix has-background-white columns" style="padding: 10px;margin-top:20px;min-height: 380px;">
            <div class="column"></div>
            <p class="content has-text-centered is-size-6" style="padding-top:120px;">
                正在加载...
            </p>
            <div class="column"></div>
        </div>
        <div v-if="!loading" class="is-clearfix has-background-white columns" style="padding: 10px;margin-top:20px;min-height: 380px; border-radius: 10px;">
            <div class="column"></div>
            <p class="content has-text-centered is-size-5 has-text-weight-semibold animated rubberBand" style="padding-top:120px; color:red;">
                系统维护中，请稍后访问！系统维护期间请勿尝试填写报名信息!
            </p>
            <div class="column"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SysStop',
    data() {
        return {
            loading: true,
            plans: []
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.doLoad()
        },
        doLoad() {
            this.loading = true
            this.$http
                .get('/comm/data/plan/running', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.plans = result.datas
                    this.loading = false
                    this.plans.forEach(plan => {
                        sessionStorage.setItem('Plan_' + plan.id, JSON.stringify(plan))
                    })
                })
        }
    }
}
</script>

<style lang="css">
@import url('./PlanList.less');
</style>
